import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import appConfig from '../../../config.js';
import Table from '../../commons/Table/Table';
import { DateStartEndField, BootstrapSelect } from '../../commons/Inputs';
// eslint-disable-next-line
import style from './CustomListGroup.css';

let $ = window.jQuery;

export default class Index extends Component {

    state = {
        data : [],
        headers : [
            {key : 'patient', label: 'Patient Name'},
            {key : 'date', label : 'Payment Date'},
            {key : 'branch', label : 'Branch Paid'},
            {key : 'procedures', label : 'Procedures'},
            {key : 'dentist', label : 'Dentist'},
            {key : 'amount_paid', label: 'Amount Paid'},
            {key : 'balance', label: 'Balance'},
            {key : 'status', label: 'Status'},
        ],
        dentists: [],
        branches: [],
        startDate: '',
        endDate: '',
        dentist: '',
        branch: '',
        earnings: 0
    };

    componentDidMount() {
        let startDate = moment().subtract(30, 'days').format('MMM DD, YYYY');
        let endDate = moment().format('MMM DD, YYYY');

        this.setState({
            startDate,
            endDate
        }, ()=>{
            this.getDentists();
            this.getBranches();
            this.getPayments();
        });
    }

    getDentists = () => {
        let url = appConfig.apiUrl + 'dental/dentists';

        axios.get(url).then((res) => {
            let dentists = [
                {
                    value: 0,
                    label: 'Select Dentist...'
                }
            ];

            dentists = dentists.concat(res.data.data);

            this.setState({
                dentists
            });

            $('#practitioner_id').selectpicker('refresh');
        });
    };

    getBranches = () => {
        let url = appConfig.apiUrl + 'management/branches';

        axios.get(url).then((res) => {

            let branches = [
                {
                    value: 0,
                    label: 'Select Clinic Branch...'
                }
            ];
            res.data.data.forEach((item, i) => {
                let tmp = {
                    value: item.id,
                    label: item.name
                };

                branches.push(tmp);
            });

            this.setState({
                branches
            });

            $('#facility_id').selectpicker('refresh');
        });
    };

    generateProceduresList = (treatmentRecords) => {
        let html = (
            <div className="">
                <ul className="list-group list-special" style={{ marginBottom: '0px' }}>
                    {treatmentRecords.map((treatment, j) => {
                            return treatment.procedures.map((procedure, i) => {
                                return <li key={i} className="list-group-item" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                                    {procedure.procedure}
                                    </li>;
                            })
                    })}
                </ul>
            </div>
        )

        return html;
    }

    generateDentistsList = (treatmentRecords) => {
        let html = (
            <div className="">
                <ul className="list-group list-special">
                    {treatmentRecords.map((treatment, i) => {
                        return <li key={i} className="list-group-item">
                            Dr.&nbsp;{treatment.practitioner.user.firstname}&nbsp;{treatment.practitioner.user.lastname}
                            </li>;
                    })}
                </ul>
            </div>
        )

        return html;
    }

    getPayments = () => {
        let startDate = moment(this.state.startDate, 'MMM DD, YYYY').format('YYYY-MM-DD');
        let endDate = moment(this.state.endDate, 'MMM DD, YYYY').format('YYYY-MM-DD');
        let practitioner_id = this.state.dentist;
        let facility_id = this.state.branch;
        let obj = {
          start_date: startDate,
          end_date: endDate,
          facility_id: facility_id,
          practitioner_id: practitioner_id
        }
        let url = appConfig.apiUrl + 'management/accounting?' + $.param(obj);

        axios.get(url).then((res) => {
            let payments = res.data.data.payments;

            payments.forEach((row) => {
                try {
                    row.patient = row.billing_statement.patient.user.firstname + ' ' + row.billing_statement.patient.user.lastname;
                    row.date = moment(row.date, 'YYYY-MM-DD').format('MMM DD, YYYY');
                    row.branch = row.facility.name;
                    row.amount_paid = parseFloat(row.price).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');

                    row.procedures = this.generateProceduresList(row.billing_statement.all_treatment_records);
                    // row.dentist = this.generateDentistsList(row.billing_statement.all_treatment_records);
                    var dentistName = '';
                    if(row.billing_statement.all_treatment_records[0].practitioner) {
                      dentistName = 'Dr. '+row.billing_statement.all_treatment_records[0].practitioner.user.firstname+' '+row.billing_statement.all_treatment_records[0].practitioner.user.lastname;
                    }
                    row.dentist = dentistName;
                    row.balance = parseFloat(row.balance).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
                    row.status = (parseFloat(row.balance.replace(',','')) > 0) ? 'Not fully paid' : 'Fully paid';
                } catch (e) {
                    console.log(e);
                }
            });

            let earnings = parseFloat(res.data.data.earnings.earnings).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            let session = localStorage.getItem('token');
            obj.access_token = session;

            this.setState({
                data: payments,
                earnings: earnings,
                printURL: appConfig.apiUrl + 'management/accounting/print?' + $.param(obj),
            });
        });
    }

    handleFilterChange = () => {
        // use state as args to endpoint
        this.getPayments();
    }

    handleDateChange = (startDate, endDate) => {
        this.setState({startDate, endDate});
    }

    makePrintPDF = () => {
      $('#previewPDF').find('iframe').prop('src', this.state.printURL);
  		$('#previewPDF').modal('show');
    }

    render() {
        return(
            <div className="page-content">

                <div className="row">
                    <div className="col-md-12">
                        <h3 className="page-title">
                            Management &nbsp; <small>Accounting</small>
                        </h3>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3 col-lg-3 col-sm-12 col-xs-12">
                        <div className="row">
                            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <div className="portlet light portlet-fit">
                                    <div className="portlet-title">
                                        <div className="caption">
                                            <i className=" icon-graph font-blue" />
                                            <span className="caption-subject font-blue sbold uppercase">Filter</span>
                                        </div>
                                    </div>
                                    <div className="portlet-body">
                                        <div className="" style={{ minHeight: '200px' }}>
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12">
                                                    <DateStartEndField start_id="start_date"
                                                                       end_id="end_date"
                                                                       startDate={this.state.startDate}
                                                                       endDate={this.state.endDate}
                                                                       onChange={this.handleDateChange}/>
                                                    <BootstrapSelect id="practitioner_id" label="Dentist"
                                                                     help="Select dentist..."
                                                                     val={this.state.dentist}
                                                                     onChange={(e) => {this.setState({dentist: e.target.value})}}
                                                                     options={this.state.dentists} />
                                                    <BootstrapSelect id="facility_id" label="Clinic Branch"
                                                                     help="Select clinic branch..."
                                                                     val={this.state.branch}
                                                                     onChange={(e) => {this.setState({branch: e.target.value})}}
                                                                     options={this.state.branches} />
                                                    <div className="row">
                                                        <div className="col-md-6 col-md-offset-6">
                                                            <button type="submit" className="btn blue-sharp"
                                                                    style={{width: '100%'}}
                                                                    onClick={this.handleFilterChange}>
                                                                Apply
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <div className="portlet light portlet-fit">
                                    <div className="portlet-title">
                                        <div className="caption">
                                            <i className=" icon-graph font-blue" />
                                            <span className="caption-subject font-blue sbold uppercase">Earnings</span>
                                        </div>
                                    </div>
                                    <div className="portlet-body">
                                        <div className="scroller" style={{ minHeight: '100px' }}>
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12">
                                                    Your clinic&rsquo;s total earnings from
                                                    <p>
                                                        <span className="bold">
                                                            {this.state.startDate}
                                                        </span>
                                                        &nbsp;to&nbsp;
                                                        <span className="bold">
                                                            {this.state.endDate}
                                                        </span>
                                                    </p>
                                                    <h1>
                                                        <p className="font-blue-sharp" style={{ textAlign: 'right' }}>
                                                            {this.state.earnings}
                                                        </p>
                                                    </h1>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-9 col-lg-9 col-sm-12 col-xs-12">
                        <div className="portlet light portlet-fit">
                            <div className="portlet-title">
                                <div className="caption">
                                    <i className=" icon-bar-chart font-blue" />
                                    <span className="caption-subject font-blue sbold uppercase">Recent</span>
                                </div>
                                <div className="actions">
                                  <button className="btn" onClick={this.makePrintPDF}>
                                    <i className="glyphicon glyphicon-print font-blue"></i>
                                    <span className="caption-subject font-blue sbold uppercase">print</span>
                                  </button>
                                </div>
                            </div>
                            <div className="portlet-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-scrollable">
                                            <Table id={"table"} headers={this.state.headers} data={this.state.data} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div id="previewPDF" data-width="900" className="modal fade in" tabIndex="-1" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        					<div className="modal-content">
        						<div className="modal-header">
        							<button type="button" className="close" data-dismiss="modal" aria-hidden="true" />
        							<h4 className="modal-title">Accounting</h4>
        						</div>
        						<div className="modal-body">
                      <iframe name="accountingFrame" style={{ width: '100%', height: '500px'}}></iframe>
        						</div>
        					</div>
        				</div>



            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/management/Accounting.js
 **/